import { getUpdatePosDataStatus, updatePosData } from '@/api/system.js';

export default {
  namespaced: true,
  state: {
    posDataStatus: {},
  },

  getters: {
    getPosDataStatus: (state) => state.posDataStatus?.status_code,
    getPosDataDescription: (state) => state.posDataStatus?.status_description,
    getPosDataLastUpdate: (state) => state.posDataStatus?.last_update_pos_date_time,
    getVersionText: (state) => {
      return `<p style="font-size: 1.8rem; margin-bottom: 8px; color: #6b6b6b">最後更新時間：${state.posDataStatus?.last_update_pos_date_time}</p>`;
    },
  },

  mutations: {
    SET_DATA(state, data) {
      state.posDataStatus = data;
    },
  },

  actions: {
    //取得商品資料更新狀態
    async checkPosDataStatus({ commit }) {
      const res = await getUpdatePosDataStatus();
      commit('SET_DATA', res);
      return Promise.resolve();
    },
    //執行更新
    async doUpdatePosData() {
      await updatePosData();
      return Promise.resolve();
    },
  },
};
